import { RequestResponse } from "../../DTO/requestResponse";
import { Request } from "../../CONSTANTS/request";
import { MICROSERVICIOS } from "../../CONSTANTS/constants";
import * as ONLY from "is-online";
import CheckVPN from "../../../SHARED/Check-VPN";

export default class UbicFisica {
  // UbicFisica.ObtenerUbicacionFisica
  static async ObtenerUbicacionFisica(datos: any): Promise<RequestResponse> {
    let direccion = "UbicacionFisica";

    if (await ONLY.default()) {
      if (await CheckVPN()) {
      // if (true) {
        return new Request(MICROSERVICIOS.UBICACION_FISICA).postUbicacionFisica(
          direccion,
          datos
        );
      } else {
        return {       
          status: -2,
          description:
            "No fue posible obtener información, No hay conexión con VPN",
          data: null,
          error: "No fue posible obtener información, No hay conexion con VPN",
        };
      }
    } else {
      return {
        status: -1,
        description:
          "No fue posible obtener información, No hay conexión a Internet",
        data: null,
        error: "No fue posible obtener información, No hay conexion a Internet",
      };
    }
  }
}
